function getVariablesByEnv() {
  switch (process.env.REACT_APP_AMB) {
    case "local":
      return {
        applicationName: "Sistema-Solicitação",
        server: "http://172.25.10.62:8080/",
        ambiente: "local",
      };

    case "dev":
      return {
        applicationName: "Sistema-Solicitação",
        server: "http://172.25.10.62:8080/",
        ambiente: "dev",
      };

    case "stage":
      return {
        applicationName: "Sistema-Solicitação",
        server: "https://spca.sspds.ce.gov.br/prod/api",
        ambiente: "stage",
      };

    case "prod":
      return {
        applicationName: "Sistema-Solicitação",
        server: "https://spca.sspds.ce.gov.br/prod/api",
        ambiente: "prod",
      };

    default:
      return {
        applicationName: "Sistema-Solicitação",
        server: "https://spca.sspds.ce.gov.br/prod/api",
      };
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...getVariablesByEnv(),
};

